const options = {
  5: "bg-emerald-100/5",
  10: "bg-emerald-100/10",
  25: "bg-emerald-100/25",
  50: "bg-emerald-100/50",
  75: "bg-emerald-100/75",
  90: "bg-emerald-100/90",
  100: "bg-emerald-100",
};

const from = {
  5: "from-emerald-100/5",
  10: "from-emerald-100/10",
  25: "from-emerald-100/25",
  50: "from-emerald-100/50",
  75: "from-emerald-100/75",
  90: "from-emerald-100/90",
  100: "from-emerald-100",
};

export default function getBackgroundEmerald100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
